export default __webpack_public_path__ + "static/media/logoo.1e1f89e5.jpeg";